module.exports = __webpack_public_path__ + "images/bck-desktop.png?e384929ade5dcd717260f0776fe231f8";